module.exports = __webpack_public_path__ + "static/media/model5-video3.ee0b8d53.jpg";